import { AddressQcBanner } from "@/features/clients/components/address-qc-banner";
import { ClientLinksSection } from "@/features/clients/components/client-links-section";
import { ClientPractitionersCard } from "@/features/clients/components/client-practitioners-card";
import { ClientProfileForm } from "@/features/clients/components/client-profile-form";
import { ClientTeamCard } from "@/features/clients/components/client-team-card";
import { DependentsSection } from "@/features/clients/components/dependents-section";
import { EmployersSection } from "@/features/clients/components/employers-section";
import { useActiveClient } from "@/layouts/client-layout";

export default function ClientProfilePage() {
  const { client, onClientUpdated } = useActiveClient();
  return (
    <div className="space-y-6">
      <AddressQcBanner warnings={client.addressQc ?? []} />
      {/* The independent sections below are passed into the form as
          `extraSections` (not rendered after it) so the form's sticky action bar
          stays the last element on the page and pins to the viewport bottom. */}
      <ClientProfileForm
        client={client}
        onClientUpdated={onClientUpdated}
        extraSections={
          <>
            {/* Assignments — editable after creation: who represents the client
                (practitioners, index 0 = primary) and which staff are assigned. */}
            <div className="grid gap-6 md:grid-cols-2">
              <ClientPractitionersCard client={client} onClientUpdated={onClientUpdated} />
              <ClientTeamCard client={client} onClientUpdated={onClientUpdated} />
            </div>
            {/* Sole-prop / individual cross-links apply to both client types. */}
            <ClientLinksSection client={client} onClientUpdated={onClientUpdated} />
            {/* Dependents/employers are 433-A individual-taxpayer concepts. */}
            {client.type === "Individual" && (
              <>
                <DependentsSection clientId={client.id} />
                <EmployersSection clientId={client.id} />
              </>
            )}
          </>
        }
      />
    </div>
  );
}
